import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requireProfessional = false, requireAdmin = false }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();
  const [authChecked, setAuthChecked] = useState(location.state?.user ? true : null);

  useEffect(() => {
    if (location.state?.user) return;
    if (!loading) {
      setAuthChecked(true);
    }
  }, [loading, location.state]);

  if (authChecked === null || loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg">Caricamento...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requireProfessional && user?.role !== 'professional') {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireAdmin && user?.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;